import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SyncPanelView from "./SyncPanelView";
import * as revaThunks from "../../../redux/thunks/revaThunks";
import * as tournamentThunks from "../../../redux/thunks/tournamentThunks";
import * as teamThunks from "../../../redux/thunks/teamThunks";
import * as lineupThunks from "../../../redux/thunks/lineupThunks";

const SyncPanelContainer = ({
    organizer,
    revaLineups,
    tournaments,
    lineups,
    loadRevaLineups,
    syncLineupWithReva,
    loadAllTournaments,
    loadAllLineups,
    match,
    loadingReva,
    loadingTournaments,
    loadingLineups,
}) => {
    const organizerId = match.params.organizerId;
    const [selectedTournamentId, setSelectedTournamentId] = useState("");

    useEffect(() => {
        loadRevaLineups();
        loadAllTournaments(0, 100, organizerId);
    }, [organizerId]);

    useEffect(() => {
        if (selectedTournamentId) {
            loadAllLineups(organizerId, selectedTournamentId);
        }
    }, [selectedTournamentId]);

    const handleSyncLineup = (lineup) => {
        const tournament = (tournaments || []).find(t => t.id === selectedTournamentId);
        syncLineupWithReva({
            ...lineup,
            external_relationship_id: selectedTournamentId,
            external_display_name: tournament?.name || "Tournament",
        });
    };

    return (
        <SyncPanelView
            revaLineups={revaLineups}
            tournaments={tournaments}
            lineups={lineups}
            selectedTournamentId={selectedTournamentId}
            setSelectedTournamentId={setSelectedTournamentId}
            handleSyncLineup={handleSyncLineup}
            loadingReva={loadingReva}
            loadingTournaments={loadingTournaments}
            loadingLineups={loadingLineups}
        />
    );
};

const mapState = (state) => ({
    organizer: state.organizer.single,
    revaLineups: state.reva.lineups,
    tournaments: state.tournament.all,
    lineups: state.lineup.all,
    loadingReva: state.loading.reva || {},
    loadingTournaments: state.loading.tournament || {},
    loadingLineups: state.loading.lineup || {},
});

const mapDispatch = (dispatch) => ({
    loadRevaLineups: () => dispatch(revaThunks.loadRevaLineups()),
    syncLineupWithReva: (data) => dispatch(revaThunks.syncLineupWithReva(data)),
    loadAllTournaments: (p, ps, oid) => dispatch(tournamentThunks.loadAllTournaments(p, ps, oid)),
    loadAllLineups: (oid, tid) => dispatch(lineupThunks.loadAllLineups(oid, tid)),
});

export default withRouter(connect(mapState, mapDispatch)(SyncPanelContainer));
